// extracted by mini-css-extract-plugin
module.exports = {"copperDotContainer":"l9epYG"};